import styled from 'styled-components';

export const SEOCarouselContainer = styled.section`
  display: grid;
  grid-template-columns: 60% 40%;
  background: ${(props) => props.color} !important;

  @media (max-width: 720px) {
    grid-template-columns: 100%;
  }
`;

export const CarouselLeftSection = styled.div`
  background: linear-gradient(to left, #f7f7f7, #f7f7f7) !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 10%;
  height: 100%;
  text-align: left;

  @media (max-width: 720px) {
    order: 2;
    padding: 10px 14px;
  }
`;

export const CarouselTitle = styled.h1`
  color: hsl(0deg, 0%, 0%, 87%);
  font-size: clamp(20px, 3vw, 30px);
`;

export const CarouselContent = styled.div`
  font-size: clamp(14px, 2vw, 16px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 54%);
  line-height: 24px;
  padding: 20px 0 10px;
  height: auto !important;
  background: none !important;
`;

export const CarouselRightSection = styled.div`
  position: relative;
  padding-top: 62.5%;
  @media (max-width: 720px) {
    background: url(https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp)
      50% center / cover no-repeat;

    padding-top: 64%;
  }

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    margin: auto;
  }
`;
